"use client";
import React, { useRef, useState } from "react";
import { getProductPackage } from "@/src/models/products";
import stl from "./productPackage.module.scss";
import { FmLoading } from "@/ui-component";
import classnames from "classnames";
import {
    IInitedInfo,
    IProductDetailsInfo,
} from "@/store/modules/productDetails";
import { IProductsPackageServerDataProps } from "@/store/modules/productPackage";
import ProductPackageItem from "./ProductPackageItem";

export interface IProductPackageProps {
    productDetail: Partial<IInitedInfo & IProductDetailsInfo>;
    packageId: number | null;
    productPackageInfo: IProductsPackageServerDataProps;
}

const ProductPackageClient: React.FC<
    React.PropsWithChildren<IProductPackageProps>
> = (props) => {
    const { productDetail, packageId, productPackageInfo } = props;
    const { products_id: productsId } = productDetail;

    const { data: package_data, pageNum, pageSize, total } = productPackageInfo;
    const scrollRef = useRef(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [packageData, setPackageData] = useState<any[]>(package_data);
    const [pageNumState, setPageNumState] = useState(pageNum);

    //获取下一页
    const getNextPageData = async () => {
        scrollRef.current = true;
        let _pageNum = pageNumState + 1;
        setPageLoading(true);
        if (!productsId) {
            return;
        }
        try {
            const arg = await getProductPackage({
                productsId,
                pageId: packageId ?? undefined,
                pageNum: _pageNum,
            });
            setPageNumState(arg.pageNum);
            setPageLoading(false);
            setPackageData((prev) => [...prev, ...arg.data]);
        } catch (e) {
            console.log(e);
        }
    };

    const preScrollXRef = useRef(0);
    const onScroll = (e: any) => {
        if (pageSize * pageNumState >= total || pageLoading) {
            return;
        }

        preScrollXRef.current = e.target.scrollLeft;
        let list_ele: any = document.getElementsByClassName(
            "product-package-href",
        )[0];
        if (e.target.scrollLeft >= list_ele.offsetWidth - 200) {
            getNextPageData();
        }
    };

    return (
        (scrollRef.current ? !!packageData.length : !!package_data.length) && (
            <div className={stl["product-package-list"]} onScroll={onScroll}>
                <div className={classnames(stl["product-package-href"])}>
                    {/* 触发滚动则使用滚动后获取的数据，否则使用传入数据 */}
                    {scrollRef.current
                        ? packageData.map((item: any, index: number) => (
                              <div key={index} style={{ flexShrink: 0 }}>
                                  <ProductPackageItem data={item} />
                              </div>
                          ))
                        : props.children}
                    <div
                        className={classnames(
                            "default_layout",
                            stl["loading-container"],
                        )}
                    >
                        <FmLoading visible={pageLoading} />
                    </div>
                </div>
            </div>
        )
    );
};

export default ProductPackageClient;
